import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    TCRBPlace,
} from '../@types';

export type TCRBItem17 = {
    tanks: TCRBItem17Tank[];
};

export type TCRBItem17Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
};

export type TCRBItem17P1 = {
    wereTankWashingDischargedDuringCleaning: boolean;
    rateOfDischarge: number; // m3/hr
};
export type TCRBItem17P2 = {
    wereTankWashingDischargedFromSlops: boolean;
    quantityDischarged: number; //m3
    rateOfDischarge: number; // m3/hr
};

export type TCRBItem17P3 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem18 = {
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBItem19 = {
    speed: number;
};

export type TCRBF1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBF;
        item17: TCRBItem17;
        item17P1: TCRBItem17P1;
        item17P2: TCRBItem17P2;
        item17P3: TCRBItem17P3;
        item18: TCRBItem18;
        item19: TCRBItem19;
    };

export type TCRBHistoryFilters = TCRBF1;

export type TCRBF = TCRBF1;

const CRBF_DEFAULTS: {
    F: TCRBF1;
} = {
    F: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item17P3: {
            placeOfBallast: {
                place: 'AT_SEA',
                startPosition: {
                    latitude: '',
                    longitude: '',
                },
                endPosition: {
                    latitude: '',
                    longitude: '',
                },
            },
        },
        item17: {
            tanks: [],
        },
        item17P1: {
            wereTankWashingDischargedDuringCleaning: false,
            rateOfDischarge: 0, // m3/hr
        },
        item17P2: {
            wereTankWashingDischargedFromSlops: false,
            quantityDischarged: 0, //m3
            rateOfDischarge: 0, // m3/hr
        },
        item18: {
            startDate: '',
            endDate: '',
            startTime: '',
            endTime: '',
        },
        item19: {
            speed: 0,
        },
        recordCode: ECRBRecordCode.CRBF,
    },
};

export { CRBF_DEFAULTS };
